import { Container } from '@/Components/Container'

const TextBlock = ({ children, className, pos = 'flex-col md:flex-row' }) => {
    return <div className={ className }>
        <Container size="max-w-[1024px]">
            <div className={ `flex items-center md:items-start ${ pos }` }>
                { children }
            </div>
        </Container>
    </div>
}

export default TextBlock
